import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { HomeService } from 'src/app/home/service/home.service';
import { WidgetModel, ActivityModel, InformationModel } from '../../../../core/models/widget.model';
import { EditFacFunnelStagesModel } from '../../../../core/models/edit-fac-modal.model';
import moment from 'moment';
import { now } from 'moment-timezone';
import {GoogleTagManagerService} from "../../../../core/analytics/google-tag-manager.service";
import {ActivitiesEnum} from "../../../../core/models/activities-enum";

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnInit, OnDestroy {

  private rawInfo: InformationModel[];
  @Input() set info(widgetInfo: InformationModel[]) {
    if (widgetInfo[0]
      && widgetInfo[0].values
      && widgetInfo[0].values.facs) {
      this.rawInfo = widgetInfo;
      this.processData();
    }
  }

  @Input() public dragged: boolean;
  @Input() public data: WidgetModel;
  @Input() public scrolling: boolean;

  public timer: any;
  public dataProcessed: boolean;
  public emptyActivities: boolean;
  public expandedSection = 0;
  public showFacModal: boolean;
  public showFacId: string;
  public showFacFunnelStage: EditFacFunnelStagesModel = {
    value: '',
    sub_items: []
  };
  public activities: ActivityModel = {
    past: { facs: [] },
    today: { facs: [] },
    tomorrow: { facs: [] },
    next_days: { facs: [] }
  };

  public activitiesEnum = ActivitiesEnum;

  constructor(private homeSvc: HomeService,
    private router: Router,
    private readonly googleTagManagerService: GoogleTagManagerService) { }

  ngOnInit() {
    moment.locale('pt-br');
    this.homeSvc.fetchWidgetData(this.data.id);
    this.timer = window.setInterval(() => {
      this.homeSvc.fetchWidgetData(this.data.id);
    }, this.data.update_timer);
  }

  ngOnDestroy() {
    window.clearInterval(this.timer);
  }

  processData() {
    if (this.rawInfo[0].values.facs.length === 0) {
      this.emptyActivities = true;
      this.dataProcessed = true;
      return;
    } else {
      const refreshActivities = {
        past: { facs: [] },
        today: { facs: [] },
        tomorrow: { facs: [] },
        next_days: { facs: [] }
      };
      for (const fac of this.rawInfo[0].values.facs) {
        const dateFac = moment(fac.compare_date);
        const today = moment();
        const tomorrow = moment().add(1, 'd');
        if (dateFac.isAfter(today) && today.date() === dateFac.date()) {
          refreshActivities.today.facs.push(fac);
        } else if (dateFac.isAfter(today) && tomorrow.date() === dateFac.date()) {
          refreshActivities.tomorrow.facs.push(fac);
        } else if (dateFac.isAfter(today) && tomorrow.date() !== dateFac.date()) {
          refreshActivities.next_days.facs.push(fac);
        } else if (today.isAfter(dateFac)) {
          refreshActivities.past.facs.push(fac);
        }
      }
      this.activities = refreshActivities;
    }
    this.dataProcessed = true;
  }

  formatDateToStringDescription(date) {
    return moment(date).fromNow();
  }

  expandSection(idx: number) {
    if (idx === this.expandedSection) {
      this.expandedSection = null;
    } else {
      this.expandedSection = idx;
    }
  }

  toggleFacModal(fac?: any, activitiesEnumType?: ActivitiesEnum) {
    if (this.scrolling) {
      return;
    }
    if (fac) {
      this.showFacModal = true;
      this.showFacId = fac.id;
      this.showFacFunnelStage = fac.funnel_stage;

      this.googleTagManagerService.pushTag({
        event: 'event',
        eventCategory: 'crm:home',
        eventAction: 'clique:widgets:tarefas-do-dia',
        eventLabel: `${activitiesEnumType}`
      });

    } else {
      this.showFacModal = false;
      this.showFacId = null;
      this.showFacFunnelStage = null;
    }
  }

}
